<template>
    <div class='mb-10'>
        <h2 class='mb-2 text-capitalize'>{{categoryName}}</h2>
        <v-divider class='mb-5'></v-divider>
         <v-row class='pl-3'>
            <div v-for='product in products' :key="product.id">
                <Product :productImage='product.image' :productName='product.name' :productId='product.id'/>
                <!-- <Product :productId='product.id' :productName='product.name' :inStock='product.in_stock' :productPrice='product.price' :productUnits='product.units_in_stock' @onProductEdit="onProductEdit" :productImage="product.image"/> -->
            </div>
        </v-row>
        
    </div>
</template>
<script>

import Product from '@/components/Product.vue'

export default {
    name:'Category',
    components: {
        Product
    },
    props:['categoryName','products'],
    methods:{
        onProductEdit(newData){
            console.log(newData);
            newData.productCategory=this.categoryName
            this.$emit('onProductEdit',newData)
        }
    }
}
</script>